export const ModuleTypes = [
	{
		viewType: 'video',
		types: [
			'video/mp4',
			'video/flv'
		]
	},
	{
		viewType: 'audio',
		types: [
			'audio/mp3',
			'audio/wav',
			'audio/mpeg'
		]
	},
	{
		viewType: 'scorm',
		types: [
			'application/x-zip-compressed'
		]
	},
	{
		viewType: 'pdf',
		types: [
			'application/pdf'
		]
	},
	{
		viewType: 'image',
		types: [
			'image/png', 
			'image/jpeg'
		]
	},
	{
		viewType: 'msdoc',
		types: [
			'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
			'application/msword',
			'application/vnd.oasis.opendocument.text',
			'application/vnd.ms-excel',
			'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
			'application/vnd.ms-powerpoint',
			'application/vnd.openxmlformats-officedocument.presentationml.presentation',
			'application/rtf',
			'application/vnd.oasis.opendocument.presentation',
			'application/vnd.oasis.opendocument.spreadsheet',
			"application/vnd.ms-publisher",
			"application/octet-stream"
		]
	},
	{
		viewType: 'txt',
		types: [
			'text/plain'
		]
	},
	{
		viewType: 'html',
		types: [
			'text/html'
		]
	},
	{
		viewType: 'epub',
		types: [
			'application/epub+zip'
		]
	}
]